module.exports = __webpack_public_path__ + "img/cursor.af8c1203.png";